import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from '../reset-password-dialog/reset-password-dialog.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  @Output()
  resetPassword = new EventEmitter<string>();

  @Input()
  email: string;

  @Input()
  readonly: boolean;

  constructor(
    public dialog: MatDialog,
  ) {

  }

  ngOnInit() {
  }

  onResetPassword() {
    const dialog = this.dialog.open(ResetPasswordDialogComponent, {
      data: {
        email: this.email,
        readonly: this.readonly
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (result && result !== '') {
        this.resetPassword.emit(result);
      }
    });
  }
}
